import { BookBase } from '@doist/icons/brand';
import { Box, Button, Heading, Image, Text } from '@doist/marketist';
import cn from 'clsx';
import { Markup } from 'components/blog-posts/markup/markup';
import { ContainerSidebar } from 'components/container-sidebar/container-sidebar';
import { useTranslation } from 'next-i18next';
import css from './side-details.module.css';
import type { Template } from 'services/templates/types';
function SideSection({
  title,
  description
}: {
  title: string;
  description: string;
}) {
  return <Box className={css.markdown} data-sentry-element="Box" data-sentry-component="SideSection" data-sentry-source-file="side-details.tsx">
            <Heading level="2" size="minor-lg" weight="semibold" className="mbe-8" data-sentry-element="Heading" data-sentry-source-file="side-details.tsx">
                {title}
            </Heading>
            <Text tag="div" size="body-sm" weight="medium" data-sentry-element="Text" data-sentry-source-file="side-details.tsx">
                <Markup tagName="fragment" content={description} data-sentry-element="Markup" data-sentry-source-file="side-details.tsx" />
            </Text>
        </Box>;
}
export function SideDetails({
  template
}: {
  template: Template;
}) {
  const {
    t
  } = useTranslation('templates');
  const moreItems = template.more_resources ? template.more_resources.filter(r => r.title !== null) : [];
  const sectionTitleKey = t(template.template_type === 'project' ? 'aboutThisTemplate' : 'aboutThisSetup');
  return <ContainerSidebar.Aside className={css.sideDetails} data-sentry-element="unknown" data-sentry-component="SideDetails" data-sentry-source-file="side-details.tsx">
            <SideSection title={sectionTitleKey} description={template.long_description} data-sentry-element="SideSection" data-sentry-source-file="side-details.tsx" />
            {template.instructions ? <SideSection title={t('instructions')} description={template.instructions} /> : null}
            <Box className={cn(css.creator, 'pbs-8 mbs-32')} data-sentry-element="Box" data-sentry-source-file="side-details.tsx">
                <Image src={template.creator.avatar} width={44} height={44} alt="" data-sentry-element="Image" data-sentry-source-file="side-details.tsx" />
                <Box data-sentry-element="Box" data-sentry-source-file="side-details.tsx">
                    <Heading level="2" size="minor-lg" weight="medium" data-sentry-element="Heading" data-sentry-source-file="side-details.tsx">
                        {template.creator.name}
                    </Heading>
                    <Text size="body-xs" weight="medium" className={css.colorSecondary} data-sentry-element="Text" data-sentry-source-file="side-details.tsx">
                        {template.creator.position}
                    </Text>
                </Box>
            </Box>
            {moreItems.length > 0 ? <Box className={cn(css.moreResources, 'mbs-32')}>
                    <Heading level="2" size="minor-lg" weight="semibold" className="mbe-8">
                        {t('moreResources')}
                    </Heading>
                    <ul>
                        {moreItems.map(resource => <li key={resource.title}>
                                <Button variant="tertiary" href={resource.url} startIcon={BookBase} iconAlign="top" bleed="inline">
                                    {resource.title}
                                </Button>
                            </li>)}
                    </ul>
                </Box> : null}
        </ContainerSidebar.Aside>;
}